<template>
  <div class="app-loading">
    <div class="create-box">
      <div id="create-icon"></div>
      <div class="text">结果生成中...</div>
    </div>
  </div>
</template>
<script>
import lottie from 'lottie-web'
export default {
  data() {
    return {}
  },
  mounted() {
    this.lottie = lottie.loadAnimation({
      container: document.getElementById('create-icon'), // the dom element that will contain the animation
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: 'https://gymvue.gymcity.com.cn/betterwe_app/%E9%97%AE%E5%8D%B7%E5%8A%A8%E6%95%88.json' // the path to the animation json
    })
    setTimeout(() => {
      this.$router.replace({
        path: '/cna-question-v2/result',
        query: this.$route.query
      })
    }, 2000)
  },
  methods: {}
}
</script>
<style scoped lang="scss">
.create-box {
  position: fixed;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
  #create-icon {
    width: 64px;
    margin: 0 auto;
  }
  .text {
    margin-top: 20px;
    font-size: 17px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #697387;
    line-height: 22px;
  }
}
</style>
